import { render, staticRenderFns } from "./PrintableReceipt.vue?vue&type=template&id=38e1f512&scoped=true&"
import script from "./PrintableReceipt.vue?vue&type=script&lang=js&"
export * from "./PrintableReceipt.vue?vue&type=script&lang=js&"
import style0 from "./PrintableReceipt.vue?vue&type=style&index=0&id=38e1f512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1f512",
  null
  
)

export default component.exports